import get from 'lodash/get';
import { createSelector } from 'reselect';
import { searchParametersSelector } from '../Serp/selectors';

export const getQueryErrorText = createSelector(
  [searchParametersSelector],
  searchParams => `${get(searchParams, 'what_d')} ${get(searchParams, 'where') || ''}`
);



// WEBPACK FOOTER //
// ./app/Error/selectors.js